var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71498 10L3.33366 10C2.62641 10 1.94814 10.281 1.44804 10.781C0.947944 11.2811 0.666992 11.9594 0.666992 12.6667V14",
    stroke: "#848491",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 7.33333C7.47341 7.33333 8.66732 6.13943 8.66732 4.66667C8.66732 3.19391 7.47341 2 6.00065 2C4.52789 2 3.33398 3.19391 3.33398 4.66667C3.33398 6.13943 4.52789 7.33333 6.00065 7.33333Z",
    stroke: "#848491",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 14.2859C13.3221 14.2859 14.8571 12.7508 14.8571 10.8573C14.8571 8.96373 13.3221 7.42871 11.4286 7.42871C9.53502 7.42871 8 8.96373 8 10.8573C8 12.7508 9.53502 14.2859 11.4286 14.2859Z",
    stroke: "#848491",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8584 11.7712C12.8584 12.5998 12.1441 13.0512 11.287 13.0512C10.6641 13.0512 10.1556 12.9369 9.74414 12.5141L10.3841 11.8741C10.5956 12.0855 10.967 12.1598 11.2927 12.1598C11.687 12.1598 11.8756 12.0283 11.8756 11.7941C11.8756 11.6969 11.8527 11.6169 11.7956 11.5541C11.7441 11.5026 11.6584 11.4626 11.527 11.4455L11.0356 11.3769C10.6756 11.3255 10.4013 11.2055 10.2184 11.0169C10.0299 10.8226 9.93843 10.5483 9.93843 10.1998C9.93843 9.45692 10.4984 8.91406 11.4241 8.91406C12.007 8.91406 12.447 9.05121 12.7956 9.39978L12.167 10.0283C11.9099 9.77121 11.5727 9.78835 11.3956 9.78835C11.047 9.78835 10.9041 9.98835 10.9041 10.1655C10.9041 10.2169 10.9213 10.2912 10.9841 10.3541C11.0356 10.4055 11.1213 10.4569 11.2641 10.4741L11.7556 10.5426C12.1213 10.5941 12.3841 10.7083 12.5556 10.8798C12.7727 11.0912 12.8584 11.3941 12.8584 11.7712Z",
    fill: "#848491"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8574,
    y: 8.57129,
    width: 1.14286,
    height: 4.57143,
    fill: "#848491"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.71f0888f425c007508008e8c80baddee.svg";
export { ForwardRef as ReactComponent };